import {
  defineComponent, ref, computed, watch, onMounted, nextTick,
} from 'vue';
import { Native, env } from '@hb/mbridge';
import { Overlay } from 'vant';
import qs from 'query-string';
import '@hb/coupon-free-compose-new';
// import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  getAppEnv,
  getSystemCode,
  isAli,
  isHelloFamilyApp,
  isWeixin,
} from '../../common/env/env';
import wisdom from '../../common/utils/wisdomConfig';
import { getCouponMallUrl } from '../../model/utils';
import { appQueryConfig, parseQueryStr } from '../../common/utils/url';
import { showThirdPage } from '../../common/utils/jumpUrl';
import { invokeJS, invoke } from '../../common/utils/wechat';
import store from '../../model/store';
import nativeMgr from '../../common/native/native';
import { appMgr } from '../../common/appMgr';
import { getStylesBinder } from '../../common/utils/styles';
import { uiMgr } from '../../common/uiMgr';
import { FreeDrawActivityCode } from './consts';
import styles from './index.module.less';

// 引入图片资源
import imgShareWx from './images/share-wx.png';

const cx = getStylesBinder(styles);

interface BannerConfigSrc {
  '2x': string;
  '3x': string;
}

interface BannerConfig {
  png: BannerConfigSrc;
  webp: BannerConfigSrc;
}

interface Config {
  banner: BannerConfig;
}

export default defineComponent({
  name: 'CouponFreeCompose',
  setup: () => {
    // 状态
    const configLoaded = ref(false);
    const showEmptyPage = ref(false);
    const showShareGuide = ref(false);
    const cityInfo = ref<any>(null);
    const compRef = ref<any>(null);

    const config = ref<Config>({
      banner: {
        png: {
          '2x': 'https://m.hellobike.com/resource/helloyun/18121/mslz__banner@2x.png',
          '3x': 'https://m.hellobike.com/resource/helloyun/18121/fSAVf_banner.png',
        },
        webp: {
          '2x': 'https://m.hellobike.com/resource/helloyun/18121/z-INl_banner@2x.webp',
          '3x': 'https://m.hellobike.com/resource/helloyun/18121/PIxCe_banner.webp',
        },
      },
    });

    // 计算属性
    const showBack = computed(() => isHelloFamilyApp);

    const showWxShare = computed(() => !isAli);

    const cityInfoParams = computed(() => {
      if (!cityInfo.value) {
        return null;
      }
      const {
        adCode = '',
        cityCode = '',
      } = cityInfo.value || {};
      return {
        adCode,
        cityCode,
      };
    });

    const compParams = computed(() => {
      const { token } = window.$$user;
      if (!token || !cityInfoParams.value) {
        return null;
      }
      // 获取当前路由参数，需要通过 uiMgr 或者 window.location 获取
      // 这里假设可以通过 uiMgr.currentRoute.query 获取，或者直接解析 URL
      const query = parseQueryStr();
      const {
        itemIdA,
        itemIdB,
      } = query;
      const {
        appId,
      } = appQueryConfig;
      const {
        adsource,
      } = query;
      const appEnv = getAppEnv();
      const {
        adCode,
        cityCode,
      } = cityInfoParams.value;
      return {
        token,
        env: appEnv,
        systemcode: getSystemCode(),
        adcode: adCode,
        citycode: cityCode,
        defaultida: itemIdA,
        defaultidb: itemIdB,
        adsource,
        appid: appId,
        safearea: true,
        'free-draw-activity-code': FreeDrawActivityCode[appEnv],
      };
    });

    const sharedUbtBizInfo = computed(() => {
      const query = parseQueryStr();
      const {
        adsource,
      } = query;
      return { adsource };
    });

    const wxShareData = computed(() => ({
      title: '我发现了出行省钱好券，随心搭配最低1分钱~~',
      desc: '我发现了出行省钱好券，随心搭配最低1分钱~~',
      link: `${getCouponMallUrl()}#/couponFreeCompose?${qs.stringify(appQueryConfig)}`,
      imgUrl: 'https://m.hellobike.com/resource/helloyun/18121/8wVIwwQk7U.png',
    }));

    // 方法
    const loadConfig = async () => {
      try {
        const conf = await wisdom.get('coupon_free_compose', config.value);
        if (conf) {
          config.value = conf;
        }
      } finally {
        configLoaded.value = true;
      }
    };

    const loadCityInfo = async () => {
      try {
        cityInfo.value = await nativeMgr.getCityInfo();
      } catch {
        // noop
      } finally {
        cityInfo.value = cityInfo.value || {};
      }
    };

    const initShare = () => {
      if (isWeixin) {
        if (env.isWechatMini) {
          const {
            link,
            imgUrl,
            title,
          } = wxShareData.value;
          invoke((wx) => {
            wx.miniProgram.postMessage({
              data: {
                command: 'customshare',
                data: {
                  title,
                  shareUrl: link,
                  imageUrl: imgUrl,
                  needLogin: true,
                },
              },
            });
          });
        } else {
          ['onMenuShareAppMessage', 'onMenuShareTimeline'].forEach((method) => {
            invokeJS(method, wxShareData.value);
          });
        }
      }
    };

    const directShare = () => {
      const {
        link,
        imgUrl,
        title,
        desc,
      } = wxShareData.value;
      const shareData = {
        tapType: 1,
        title,
        desc,
        shareUrl: link,
        content: '我发现了出行省钱好券，随心搭配最低1分钱~',
        imageUrl: imgUrl,
        shareImageUrl: imgUrl,
        qrShareBg: imgUrl,
        miniProgramId: 'gh_cae4bd7d6f14',
        miniProgramPath: `/pages/web-view/web-view?url=${encodeURIComponent(link)}&auth=1&appId=wxb937e3d0b3ca117e`,
        miniProgramType: getAppEnv() === 'pro' ? 0 : 1,
      };
      Native.callNative({
        classMap: 'Share',
        method: 'directItemShare',
        params: shareData,
      });
    };

    const handleTokenOutdated = () => {
      appMgr.relogin();
    };

    const handleBack = () => {
      try {
        Native.goBack();
      } catch (error) {
        window.history.go(-1);
      }
    };

    const handleMoreCoupon = () => {
      // todo: 更多卡券点击
      // UBT.clickButton({
      //   pageId: 'platform_couponmatch_homepage',
      //   buttonName: 'platform_fubiao_moreCoupons',
      //   categoryId: 'platform',
      //   businessInfo: {},
      // });

      let adsource = 'couponCompose_homepage';
      if (isAli) {
        adsource = 'zhifubao_couponCompose_homepage';
      }
      if (isWeixin) {
        adsource = 'weixin_couponCompose_homepage';
      }
      if (isHelloFamilyApp) {
        adsource = 'app_couponCompose_homepage';
      }

      const url = getAppEnv() !== 'pro'
        ? `https://m.hellobike.com/AppPlatformH5/${getAppEnv()}/latest/index.html#/bounty?adsource=${adsource}&pageTab=coupon`
        : `https://m.hellobike.com/AppPlatformH5/latest/index.html#/bounty?adsource=${adsource}&pageTab=coupon`;
      showThirdPage(url);
    };

    const handleLinkRule = () => {
      // todo: 规则点击
      // UBT.clickButton({
      //   pageId: 'platform_couponmatch_homepage',
      //   buttonName: 'platform_activityrules',
      //   categoryId: 'platform',
      //   businessInfo: sharedUbtBizInfo.value,
      // });
      showThirdPage('https://m.hellobike.com/mf/spa/u_iixyfp/latest/MA2401154927165694625187771.html?activityCode=MA2401154927165694625187771');
    };

    const handleLinkOrder = () => {
      // todo: 订单点击
      // UBT.clickButton({
      // pageId: 'platform_couponmatch_homepage',
      // buttonName: 'platform_orderlist',
      //   categoryId: 'platform',
      //   businessInfo: sharedUbtBizInfo.value,
      // });
      uiMgr.pushPage({
        path: 'order',
        query: {
          activityId: 'FREE_CMN_MALL_ACT',
        },
      });
    };

    const handleShare = () => {
      // todo: 分享点击
      // UBT.clickButton({
      //   pageId: 'platform_couponmatch_homepage',
      //   buttonName: 'platform_activityshare',
      //   categoryId: 'platform',
      //   businessInfo: sharedUbtBizInfo.value,
      // });

      if (isHelloFamilyApp) {
        directShare();
      } else {
        showShareGuide.value = true;
      }
    };

    // Watchers
    watch(compParams, (val) => {
      if (val) {
        nextTick(() => {
          const { userGuid } = store.state.user.userInfo;
          if (compRef.value && compRef.value.ubtBindData) {
            compRef.value.ubtBindData({
              userGuid,
              ...cityInfo.value,
            });
          }
        });
      }
    }, { immediate: true });

    // 生命周期
    onMounted(() => {
      loadConfig();
      loadCityInfo();
      initShare();

      if (isHelloFamilyApp) {
        // 原有的 HelloFamilyApp 逻辑
        Native.callNative({
          classMap: 'NavBar',
          method: 'setStatusBar',
          params: { isShowStatusBar: true },
        });
        Native.callNative({
          classMap: 'NavBar',
          method: 'setStatusBarColor',
          params: {
            isShowStatusBar: true,
            isDarkFont: true,
            colorCode: '#000000',
          },
        });
      }
    });

    return () => (
      <div
        class={cx('container', {
          'not-app': !isHelloFamilyApp,
          empty: showEmptyPage.value,
        })}
      >
        <div class={cx('container__content')}>
          {configLoaded.value && (
            <div class={cx('header')} key="header">
              {!showEmptyPage.value && (
                <picture>
                  <source
                    srcset={`${config.value.banner.webp['2x']} 2x, ${config.value.banner.webp['3x']} 3x`}
                    type="image/webp"
                  />
                  <img
                    class={cx('header__banner')}
                    src={config.value.banner.png['2x']}
                    srcset={`${config.value.banner.png['2x']} 2x, ${config.value.banner.png['3x']} 3x`}
                    width="375"
                    height="194"
                  />
                </picture>
              )}
              <div class={cx('header__content')}>
                <div class={cx('header__safe-area')} />
                <div class={cx('header__nav')}>
                  <div class={cx('header__back-wrap')}>
                    {showBack.value && (
                      <div
                        class={cx('header__back')}
                        onClick={handleBack}
                      />
                    )}
                  </div>
                  <div class={cx('header__link-list')}>
                    <div
                      class={cx('header__link', 'header__link--rule')}
                      onClick={handleLinkRule}
                    >
                      规则
                    </div>
                    <div
                      class={cx('header__link', 'header__link--order')}
                      onClick={handleLinkOrder}
                    >
                      订单
                    </div>
                  </div>
                </div>
                {showWxShare.value && (
                  <img
                    class={cx('header__share-wx')}
                    width="34"
                    height="34"
                    src={imgShareWx}
                    onClick={handleShare}
                  />
                )}
              </div>
            </div>
          )}
          <div class={cx('main')} key="main">
            <div class={cx('main__content')}>
              {compParams.value && (
                <quark-cfc
                  {...{ attrs: compParams.value }}
                  ref={compRef}
                  class={cx('comp')}
                  onData-empty={() => { showEmptyPage.value = true; }}
                  onToken-outdated={handleTokenOutdated}
                />
              )}
            </div>
            {!showEmptyPage.value && (
              <aside>
                <Overlay
                  show={showShareGuide.value}
                  zIndex={10}
                  onClick={() => { showShareGuide.value = false; }}
                >
                  <img
                    src="https://m.hellobike.com/resource/helloyun/18121/5VlvE_share-wx-guide@2x.png"
                    srcset="https://m.hellobike.com/resource/helloyun/18121/5VlvE_share-wx-guide@2x.png 2x, https://m.hellobike.com/resource/helloyun/18121/efrfi_share-wx-guide.png 3x"
                    width="228"
                    height="170"
                    alt="引导图片"
                    class={cx('wx-share-guide')}
                  />
                </Overlay>
              </aside>
            )}
          </div>
        </div>
        <div class={cx('container__pop')}>
          <div class={cx('text')}>
            没有合适的卡券？
          </div>
          <div
            class={cx('btn')}
            onClick={handleMoreCoupon}
          >
            <div class={cx('btn-text')}>
              更多卡券
            </div>
            <img
              src="https://m.hellobike.com/helloyun3/28831/zn8tel3a_Vector.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    );
  },
});
